module.exports = __webpack_public_path__ + "img/files.9480204a.svg";